import { Injectable } from '@angular/core'
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { throwError } from 'rxjs'
import { environment } from 'src/environments/environment'

/** Gallery fixtures must never fall through to a real application API. */
@Injectable()
export class ShowcaseIsolationInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    const gallery = !environment.production && (window.location.pathname.startsWith('/dev/style-guide') || window.location.pathname === '/design-system')
    if (gallery && request.url.startsWith(environment.api + '/')) {
      return throwError(() => new HttpErrorResponse({ status: 403, statusText: 'Showcase API isolation', url: request.url }))
    }
    return next.handle(request)
  }
}
